var map = {
	"./et-pk-en/styles/index.js": 85596,
	"./gp-bd-en/styles/index.js": 87841,
	"./mtn-wp-za-en/styles/index.js": 80034,
	"./mtn-za-en/styles/index.js": 60172,
	"./telkom-wp-za-en/styles/index.js": 98461,
	"./vc-encrypt-za-en/styles/index.js": 98146,
	"./vc-za-en-demo/styles/index.js": 3092,
	"./vc-za-en/styles/index.js": 94038,
	"./wp-za-en/styles/index.js": 38953
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 19035;